import { InvestorsBlock } from 'routes/components/Features/InvestorsBlock'
import classes from './AboutUsInvestors.module.scss'

export const AboutUsInvestors = () => {
  return <InvestorsBlock className={classes.section} />
}
